export default [
    {
        path: 'relatorio-acesso-cuidado-programado',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-acesso-cuidado-programado' */
            '@/views/atencao-basica/relatorio-acesso-cuidado-programado/Index'
        ),
        redirect: 'relatorio-acesso-cuidado-programado/index',
        children: [
            {
                name: 'atencao-basica-relatorio-acesso-cuidado-programado-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-acesso-cuidado-programado' */
                    '@/views/atencao-basica/relatorio-acesso-cuidado-programado/List.vue'
                ),
            },
        ],
    },
]